import { IBannerSecondaryResponseModel } from "../../core/models";
import "./bannersecondary.scss";

export interface IBannerBannerSecondaryProps {
  content: IBannerSecondaryResponseModel;
}

const BannerSecondary = ({ content }: IBannerBannerSecondaryProps) => {
  return (
    <section className="banner-detail">
      <div className="banner-detail__top">
        <img
          className="banner-detail__head-image"
          src={content.image?.src}
          width={375}
          height={100}
          alt={content.image?.alt}
          style={{ height: "auto", width: "100%" }}
        />
        <h2 className="banner-detail__title">{content.title}</h2>
      </div>
    </section>
  );
};

export default BannerSecondary;
